class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);

    // animation trigger
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* -------------------------------------------------------------------------- */
/* 💤 Cart Drawer Upsell Slider Controls                                      */
/* -------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById('cartUpsellSlider');
  const leftArrow = document.querySelector('.cart__upsell-arrow--left');
  const rightArrow = document.querySelector('.cart__upsell-arrow--right');

  if (slider && leftArrow && rightArrow) {
    leftArrow.addEventListener('click', () => {
      slider.scrollBy({ left: -220, behavior: 'smooth' });
    });
    rightArrow.addEventListener('click', () => {
      slider.scrollBy({ left: 220, behavior: 'smooth' });
    });
  }
});

/* -------------------------------------------------------------------------- */
/* 💤 Official Shopify-compatible Add to Cart for Upsell                      */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/* 💤 Reusable Upsell Slider Setup                                            */
/* -------------------------------------------------------------------------- */
function initUpsellSlider() {
  const slider = document.getElementById('cartUpsellSlider');
  const leftArrow = document.querySelector('.cart__upsell-arrow--left');
  const rightArrow = document.querySelector('.cart__upsell-arrow--right');

  if (!slider || !leftArrow || !rightArrow) return;

  leftArrow.addEventListener('click', () => {
    slider.scrollBy({ left: -220, behavior: 'smooth' });
  });

  rightArrow.addEventListener('click', () => {
    slider.scrollBy({ left: 220, behavior: 'smooth' });
  });
}

// initialize once at load
document.addEventListener('DOMContentLoaded', initUpsellSlider);

/* -------------------------------------------------------------------------- */
/* 💤 Official Shopify-compatible Add to Cart for Upsell                      */
/* -------------------------------------------------------------------------- */
function addUpsellToCart(variantId) {
  console.log("🛏 Adding variant:", variantId);

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  fetch('/cart/add', {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' },
    credentials: 'same-origin'
  })
    .then(async (response) => {
      const data = await response.json();
      console.log('Shopify add response:', data);

      if (!response.ok) {
        throw new Error(data.description || 'Add to cart failed');
      }

      // ✅ fetch updated drawer HTML sections
      return fetch(`/?sections=cart-drawer,cart-icon-bubble`);
    })
    .then(res => res.json())
    .then(sections => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        const cartDrawerEl = document.getElementById('CartDrawer');
        const cartIconEl = document.getElementById('cart-icon-bubble');

        if (cartDrawerEl && sections['cart-drawer']) {
          cartDrawerEl.innerHTML = new DOMParser()
            .parseFromString(sections['cart-drawer'], 'text/html')
            .querySelector('#CartDrawer').innerHTML;
        }

        if (cartIconEl && sections['cart-icon-bubble']) {
          cartIconEl.innerHTML = new DOMParser()
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }

        // reopen drawer
        drawer.classList.add('active');
        document.body.classList.add('overflow-hidden');

        // 🪄 re-initialize the upsell slider after new HTML injected
        initUpsellSlider();
      }

      // small button feedback
      const btn = document.activeElement;
      if (btn && btn.classList.contains('cart__upsell-button')) {
        btn.textContent = 'Added!';
        btn.disabled = true;
        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2000);
      }
    })
    .catch(error => {
      console.error('Upsell Add Error:', error);
      alert('Sorry, something went wrong adding this product.');
    });
}
document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('.cart__info-slide');
  const progressFill = document.querySelector('.cart__info-progress-fill');
  let index = 0;
  const duration = 3000;

  function showNextSlide() {
    slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
    progressFill.style.width = '0%';
    setTimeout(() => (progressFill.style.width = '100%'), 50);
    index = (index + 1) % slides.length;
  }

  if (slides.length > 0) {
    showNextSlide();
    setInterval(showNextSlide, duration);
  }
});
